<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-6" v-if="service">
        <div class="box">
          <div class="box-title">서비스 기본 정보</div>
          <div>
            <div class="flex-between">
              <div class="box-sub-title">회원 아이디</div>
              <div class="box-sub-content" style="text-decoration:underline">{{ service.service_user.email }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">서비스명</div>
              <div class="box-sub-content">{{ service.service_name }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">서비스 이용 시작일</div>
              <div class="box-sub-content">{{ datesFormat(service.created_time, 'date_4') }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">도메인</div>
              <div class="box-sub-content">{{ domain }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">백오피스</div>
              <div class="box-sub-content">{{ domain }}/office/admin</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">서비스 이용상태</div>
              <div class="box-sub-content">{{ service.status_kor }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="service_info">
        <div class="box">
          <div class="box-title">사업자 정보</div>
          <div>
            <div class="flex-between">
              <div class="box-sub-title">회사명</div>
              <div class="box-sub-content">{{ service_info.business_info.company }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">대표자명</div>
              <div class="box-sub-content">{{ service_info.business_info.ceo_name }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">이메일</div>
              <div class="box-sub-content">{{ service_info.service_center.email }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">연락처</div>
              <div class="box-sub-content">{{ service_info.business_info.call }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">사업자 등록번호</div>
              <div class="box-sub-content">{{ service_info.business_info.business_num }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">통신판매신고번호</div>
              <div class="box-sub-content">{{ service_info.business_info.ecommerce_num }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">회사주소</div>
              <div class="box-sub-content"
                   v-if="service_info.business_info.address">{{ service_info.business_info.address.full }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="service.manager">
        <div class="box">
          <div class="box-title">서비스 담당자 정보</div>
          <div>
            <div class="flex-between">
              <div class="box-sub-title">담당자명</div>
              <div class="box-sub-content">{{ service.manager.name }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">이메일</div>
              <div class="box-sub-content">{{ service.manager.email }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">연락처</div>
              <div class="box-sub-content">{{ service.manager.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6" v-if="service.service_order">
        <div class="box">
          <div class="box-title">솔루션 정보</div>
          <div>
            <div class="flex-between">
              <div class="box-sub-title">케어서비스</div>
              <div class="box-sub-content" v-if="service.service_order.care_service">{{ service.service_order.care_service.name }}</div>
            </div>
            <div class="flex-between">
              <div class="box-sub-title">호스팅</div>
              <div class="box-sub-content" v-if="service.service_order.hosting">{{ service.service_order.hosting.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box" v-if="service.service_order">
          <div class="flex-between">
            <div class="box-title">서비스 결제 정보</div>
            <button class="button" style="background:#B6BECB;color:white" @click="$modal.show('terminateServiceModal');">서비스 해지</button>
          </div>
          <div>
            <div class="main size-13 bold">서비스 월 결제 플랜 정보</div>
            <div class="columns is-multiline" style="margin-top:18px">
              <div class="column is-4" v-if="service.service_order.care_service">
                <div class="flex-between">
                  <div class="sub3">케어서비스</div>
                  <div class="size-12">{{ service.service_order.care_service.price | currency }}</div>
                </div>
                <div class="flex-end size-12">{{ this.datesFormat(service.service_order.pay_day, 'date_4') }} 최근 결제</div>
                <div class="flex-end size-12">{{ this.datesFormat(service.service_order.next_date, 'date_4') }} 결제 예정</div>
              </div>
              <div class="column is-4" v-if="service.service_order.hosting">
                <div class="flex-between">
                  <div class="sub3">호스팅</div>
                  <div class="size-12">{{ service.service_order.hosting.price | currency }}</div>
                </div>
                <div class="flex-end size-12">{{ this.datesFormat(service.service_order.pay_day, 'date_4') }} 최근 결제</div>
                <div class="flex-end size-12">{{ this.datesFormat(service.service_order.next_date, 'date_4') }} 결제 예정</div>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="sub3">카드정보</div>
                {{ service.service_order.bill.num }}/{{ service.service_order.bill.bank }}
              </div>
              <div class="column is-6">
                <div class="flex-between">
                  <div class="sub3">월 결제 총액</div>
                  <div>{{ service.service_order.subscribe_price | currency }}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:32px">
            <div class="flex-between" style="margin-bottom:12px">
              <div class="main size-13 bold">회원 최근 결제 내역</div>
              <button class="button is-primary-light" @click="routerPush('bill/payment')">전체 내역 보기</button>
            </div>
            <table class="table service-info-detail-table" v-if="bill_history.length>0">
              <tr>
                <th>날짜</th>
                <th>상품명</th>
                <th>금액</th>
                <th>구분</th>
              </tr>
              <template v-for="(hi, h_idx) in bill_history">
                <tr :key="`history-${h_idx}`">
                  <td>{{ hi.created_time }}</td>
                  <td>{{ hi.title }}</td>
                  <td>{{ hi.price | currency }}</td>
                  <td>{{ hi.is_cancel?'취소완료':'결제완료' }}</td>
                </tr>
              </template>
            </table>
            <div style="text-align:center;font-size:12px" v-if="bill_history.length===0">최근 결제 내역이 없습니다.</div>
          </div>
        </div>
      </div>
    </div>

    <modal name="terminateServiceModal" :adaptive="true" height="auto" class="modal-style" :clickToClose="false">
      <admin-box-item title="서비스 해지" :useTab="false" class="lp-modal-wrapper">
        <div>정말 서비스를 해지시키겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('terminateServiceModal')">취소</button>
          <button class="button is-primary" @click="confirmTerminateService">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>
<script>
  export default {
    name: "ServiceInfoDetail",
    created() {
      this.getService();
      this.getServiceInfo();
      this.getBillHistory();
    },
    data() {
      return {
        bill_history: [],
        service: undefined,
        service_info: undefined,
        domain: ''
      }
    },
    methods: {
      confirmTerminateService() {
        this.$axios.post('admin/launchpack/service/terminate').then(res=>{
          this.toast('서비스 해지 요청이 완료되었습니다.');
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      getBillHistory() {
        this.$axios.get('admin/launchpack/service/bill/history').then(res=>{
          this.bill_history = res.data.data;
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      getService() {
        this.$axios.get('admin/launchpack/service/info').then(res=>{
          this.service = res.data;
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      getServiceInfo() {
        this.$axios.get('admin/service/info').then(res=> {
          this.service_info = res.data;
        })
        this.$axios.get('admin/service/domain')
          .then( res => {
            if(res.status === 200) {
              this.domain = res.data.domain;
            }
          });
      }
    }
  }
</script>
<style lang="stylus">
  .service-info-detail-table th
    border 0 !important
    font-weight 400
    font-size 14px
  .service-info-detail-table td
    font-size 14px

  .service-info-detail-table tr
    border-bottom 1px solid #dbdbdb
</style>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
    .box-sub-title
      font-size 13px
      color $sub3
      width 110px
    .box-sub-content
      font-size 13px
      color $main
    .box-title
      font-size 21px
      color $main
      margin-bottom 24px
</style>
